<template>
  <div>
    <el-container>
      <el-main style="padding: 15px 20px 15px;">
        <!-- {{formData}} -->
        <search-bar ref="search" :isReported="isReported" @search="handleSearch"></search-bar>
      </el-main>
    </el-container>

    <el-container>
      <!-- {{isReported}} -->
      <!-- opration bar -->
      <el-header height="32px" style="line-height: 32px; margin-bottom: 15px; width: 100%;" v-if="!isReported">
        <el-button type="primary" size="small" @click="packExport">导出</el-button>
        <template v-if="!isReported">
          <el-button type="primary" size="small" @click="importFile">导入</el-button>
        </template>
        <template v-else>
          <el-button type="primary" size="small" disabled>导入</el-button>
        </template>
        <template v-if="isAbleReport && !isReported">
          <el-button type="primary" size="small" @click="planSubmit">提报</el-button>
        </template>
        <template v-else>
          <el-button type="primary" size="small" disabled>提报</el-button>
        </template>
        <span style=" color:#999;">！提报后不可再编辑修改</span>
        <report-info v-if="!isReported" style="float: right;"></report-info>
      </el-header>
    </el-container>

    <el-container>
      <el-main class="table-wrapper" style="padding: 0 20px 10px 20px">
        <!-- form -->
        <el-form :model="rowData" class="ruleForm" :rules="rules" ref="ruleForm">
          <!-- table -->
          <el-table
            ref="table"
            border
            :data="tableData"
            :height="tableHeight+'px'"
            @sort-change="handleSortChange"
            v-loading="tableData === null"
            v-if="tableHeight">
            <el-table-column fixed label="包件编码" prop="packCode" width="120PX" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.packCode" placement="top" :open-delay="500">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.packCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed label="包件名称" prop="packName" min-width="280PX" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.packName" placement="top" :open-delay="500">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.packName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- <el-table-column label="销售定位" prop="saleLocation" width="160px" align="center">
              <template slot-scope="scope">
                <el-form-item v-if="scope.row.editable" prop="saleLocation">
                  <sale-select v-model="rowData.saleLocation" ></sale-select>
                </el-form-item>
                <span v-else>{{scope.row.saleLocationName}}</span>
              </template>
            </el-table-column> -->
            <template v-if="!isReported">
              <el-table-column :label="`${upperCurrentMonth}月预估调整`" prop="subMonthPreviousAdjust" width="150px" align="right" sortable="custom"></el-table-column>
              <el-table-column :label="`当月调整后量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom"></el-table-column>
            </template>
            <el-table-column :label="`${currentMonth}月预估`" prop="subMonthPlan" width="160PX" align="right" sortable="custom"></el-table-column>
            <el-table-column :label="`${currentMonth}月预估调整`" prop="subMonthAdjust" width="160PX" align="right" sortable="custom">
              <template slot-scope="scope">
                <el-form-item v-if="scope.row.editable" prop="subMonthAdjust">
                  <el-input v-model.trim="rowData.subMonthAdjust" size="mini" @input="handleNextMonthAdjustChange(rowData)"></el-input>
                </el-form-item>
                <span v-else>{{scope.row.subMonthAdjust}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`当月调整后量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom"></el-table-column>
            <template v-if="isReported">
                <el-table-column :label="`${parseInt(currentMonth)}月初次预估调整`" prop="subMonthHistoryPlanAdjust" width="150px" align="right" sortable="custom"></el-table-column>
            </template>
            <el-table-column :label="`${currentMonth}月大促预估`" prop="subMonthPromotion" width="160PX" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[0].nodeName">
              <template slot-scope="scope">
                <el-form-item v-if="scope.row.editable" prop="subMonthPromotion">
                  <el-input v-model.trim="rowData.subMonthPromotion" size="mini"></el-input>
                </el-form-item>
                <span v-else>{{scope.row.subMonthPromotion}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column :label="`大促预估调整`" prop="subMonthPromotionAdjust" width="160PX" align="right" sortable="custom" v-if="isReported && columnsPromotion && columnsPromotion[0].nodeName"></el-table-column> -->
            <el-table-column label="调整量" prop="subMonthDiffAmount" width="120PX" align="right" sortable="custom">
              <template slot-scope="scope">
                <span>{{scope.row.subMonthDiffAmount}}</span>
              </template>
            </el-table-column>

            <!-- 历史月份不展示N+1、N+2预估数据 -->
            <template v-if="!isReported">
              <el-table-column :label="`${nextCurrentMonth}月预估`" prop="subMonthNextPlan" width="160PX" align="right" sortable="custom">
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.editable" prop="subMonthNextPlan">
                    <el-input v-model.trim="rowData.subMonthNextPlan" size="mini"></el-input>
                  </el-form-item>
                  <span v-else>{{scope.row.subMonthNextPlan}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="`${nextCurrentMonth}月大促预估`" prop="subMonthNextPromotion" width="160PX" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[1].nodeName">
                <template slot-scope="scope">
                  <el-form-item v-if="scope.row.editable" prop="subMonthNextPromotion">
                    <el-input v-model.trim="rowData.subMonthNextPromotion" size="mini"></el-input>
                  </el-form-item>
                  <span v-else>{{scope.row.subMonthNextPromotion}}</span>
                </template>
              </el-table-column>
            </template>

            <!-- <el-table-column label="货源储备要求" prop="resourceReserve" width="160PX" align="right" sortable="custom">
              <template slot-scope="scope">
                <el-form-item v-if="scope.row.editable">
                  <el-input v-model.trim="rowData.resourceReserve" size="mini" maxlength="50"></el-input>
                </el-form-item>
                <el-tooltip class="item" effect="dark" :content="scope.row.resourceReserve" placement="top" :open-delay="500" v-else>
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.resourceReserve}}</span>
                </el-tooltip>
              </template>
            </el-table-column> -->
            <!-- 当前月份为提报月份显示操作栏 -->
            <!-- <el-table-column label="操作" width="130PX" align="right" fixed="right" sortable="custom" v-if="!isReported"> -->
            <el-table-column label="操作" width="130PX" align="right"  sortable="custom" v-if="!isReported">
              <template slot-scope="scope" v-if="!isReported">
                <el-button type="text" @click="rowModify(scope.row)" v-if="!scope.row.editable">编辑</el-button>
                <template v-else>
                  <el-button type="text" @click="updateRow(scope.row)">保存</el-button>
                  <el-button type="text" @click="cancel">取消</el-button>
                </template>
                <el-button type="text" @click="historySale(scope.row)">历史销量</el-button>
              </template>
            </el-table-column>
            <!-- 不是提报月份显示其他数据列 -->
            <template v-if="isReported">
              <el-table-column label="直播销量" prop="planLiveSalesResult" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="实际销量" prop="salesResult" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="截止3日销量（不含直播）" prop="endSalesResult" width="160PX" align="right" sortable="custom">
                <template #header>
                  <span>截止3日销量</span>
                  <el-tooltip class="item" effect="dark" content="（不含直播）" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="当前应售" prop="finalPlanAmount" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预估差额" prop="diffAmount" width="120PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预估差异率" prop="diffRate" width="120PX" align="right" sortable="custom" class-name="tooltip">
                <template #header>
                  <span>预估差异率</span>
                  <el-tooltip class="item" effect="dark" content="（实际销量-当前应售）/当前应售" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-link type="danger" :underline="false" v-if="scope.row.diffRate > 0.2||scope.row.diffRate < -0.2">{{scope.row.diffRate*100|formatFloat}}%</el-link>
                  <span v-else>{{scope.row.diffRate*100|formatFloat}}%</span>
                </template>
              </el-table-column>
              <el-table-column label="预估情况" prop="status" width="120PX" align="right" sortable="custom"></el-table-column>
            </template>
          </el-table>
        </el-form>

        <!-- pagination -->
        <div style="overflow: hidden;">
          <div style="float: left; margin-top: 15px; color: #555;">
            <span>{{dataUpdateObj.updateContent}}：</span>
            <span>{{dataUpdateObj.latestUpdateTime}}</span>
          </div>
          <el-pagination
            style="float: right; margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>

        <!-- dialog -->
        <v-dialog v-model="historyVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
          <div slot="content">
            <history-sale :data="{...rowData, ...form, ...formData}" v-if="dialogType === 'history' && historyVisible"></history-sale>
          </div>
        </v-dialog>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import moment from 'moment'

  import searchBar from './components/searchBar/searchBar'
  import saleSelect from '@/views/preSalePlan/common/saleSelect'

  import historySale from './components/history-sale/history-sale'

  import reportInfo from './components/report-info/report-info'

  import {mapGetters} from 'vuex'
  import * as Global from '@/utils/Global.js'
  import {isInt} from '@/utils/validate.js'

  export default {
  mixins: [mixin, pagePathMixin],
  components: { searchBar, saleSelect, historySale, reportInfo },
  props: ['form', 'dataUpdateObj', 'cachedComponents'],
  data() {
    const numberValid = (rule, value, callback) => {
      if(value=='' || value == 0) {
        callback();
        return;
      }
      let status = isInt(value);
      if(status) {
        callback()
      }else{
        callback(new Error('必须是数字'))
      }
    }
    return {
      formData: {},
      columnsPromotion: null,
      tableData: null,
      tableHeight: 0,
      paginationOpt: {
        pageSizes: [30, 60, 90, 500],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      // dialog
      dialogType: '',
      rowData: null,
      // 历史销量
      historyVisible: false,
      dialogConfig: {},
      rules: {
        subMonthAdjust: [
          { validator: numberValid, trigger: 'change' }
        ],
        subMonthPromotion: [
          { validator: numberValid, trigger: 'change' }
        ],
        subMonthNextPlan: [
          { validator: numberValid, trigger: 'change' }
        ],
        subMonthNextPromotion: [
          { validator: numberValid, trigger: 'change' }
        ],
      },
      // table 升序降序
      descOrAsc: '',
      fieldName: ''
    }
  },
  computed: {
    ...mapGetters({
      //是否已提报
      isReported: 'isReported'
    }),
    // 当前所在月份
    currentMonth() {
      return this.form.planTime.split('-')[1]
    },
    // 当前所在月份的下一个月
    nextCurrentMonth() {
      let currentMonth = +this.currentMonth;
      currentMonth = currentMonth + 1;
      currentMonth = currentMonth > 12 ? currentMonth - 12 : currentMonth;
      return currentMonth;
    },
    // 当前所在月份的上一个月
    upperCurrentMonth() {
      let currentMonth = +this.currentMonth;
      currentMonth = currentMonth - 1;
      currentMonth = currentMonth  == 0 ? 12 : currentMonth;
      return currentMonth;
    },
    // 是否可以提报
    isAbleReport() {
      if(this.isReported) return false;

      let tableData = this.tableData;
      if(!tableData || !tableData.length) return false;

      // 每一行的下列四个字段，至少要有一列的一个值不为空。
      let validRow = tableData.filter(v=>{
        let num = v['subMonthAdjust'] + v['subMonthPromotion'] + v['subMonthNextPlan'] + v['subMonthNextPromotion'];
        v['summary'] = num;
        return num !== ''
      });
      if(validRow.length === 0){
         return false
      }else{
        return true
      };

      // 不为空的数据行，当值大于0时，必须选择销售定位
      // validRow = validRow.filter(v=>v['summary'] > 0);
      // if(validRow.length === 0) return true;

      // let has_SaleLocation = validRow.filter(v=>v['saleLocation']);
      // return has_SaleLocation.length === validRow.length && true || false
    },
  },
  mounted() {
    this.addListener_refresh();
    this.getColumns_promotion();
    this.$nextTick(_=>{
      this.init();
    })
  },
  methods: {
    async getColumns_promotion() {
      let params = {
        planTime: this.form.planTime
      }
      let res = await this.$q.preSalePlan.predictionNodeGet({params});
      if(res.success && res.data && res.data.length) {
        this.columnsPromotion = res.data;
      }else{
        this.columnsPromotion = [];
      }
    },
    handleSearch(data,type) {
      if(type == 1) {
        this.descOrAsc = '';
        this.fieldName = '';
        this.$nextTick(_=>{
          this.$refs.table.clearSort()
        })
      }
      this.formData = data;
      // 重置分页
      this.paginationOpt['pageNum'] = 1;
      this.init();
    },
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', _=>{
        this.tableHeight = 0;
        this.$nextTick(_=>{
          // 重置搜索条件
          this.formData = { };
          if(this.$refs['search']) {
            this.$refs['search'].form = {};
          }
          // this.formData = { saleLocation: ''};
          // this.$refs['search'].form = { saleLocation: ''};
          // 重置分页
          this.paginationOpt['pageNum'] = 1;
          this.paginationOpt['pageSize'] = 30;
          this.getColumns_promotion();
          this.init();
        });
      });
    },
    async init() {
      this.tableHeight = document.documentElement.clientHeight - (!this.isReported ? 370 : 325)
      this.tableData = null;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: {
          ...this.form,
          ...this.formData,
          descOrAsc: this.descOrAsc,
          fieldName: this.fieldName
        }
      };

      let res;
      if(!this.isReported) {
        // 未提报
        res = await this.$q.preSalePlan.prePlanPackUnSubListPage({data})
      }else{
        // 已提报
        res = await this.$q.preSalePlan.prePlanPackSubListPage({data})
      }

      if(res && res.success && res.data) {
        this.tableData = res.data.records;
        this.paginationOpt.total = res.data.total;
      }else{
        this.tableData = [];
        this.paginationOpt.total = 0;
      }
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    // row 编辑
    rowModify(row) {
      this.tableData.forEach(item=>this.$set(item, 'editable', false));
      this.rowData = row;
      this.$set(row, 'editable', true);
    },
    cancel(row) {
      this.$set(row, 'editable', false);
      this.init();
    },
    // row 保存
    async updateRow(row) {
      this.$refs['ruleForm'].validate(async valid=>{
        if(valid){
          // let index = [row['subMonthAdjust'], row['subMonthPromotion'], row['subMonthNextPlan'], row['subMonthNextPromotion']].findIndex(v=>v>0)
          // if(index > -1 && !row['saleLocation']) {
          //   this.$message('请选择销售定位');
          //   return;
          // }
          let data = {
            packCode: row.packCode,
            // saleLocation: row.saleLocation,
            planTime: this.form.planTime,
            subMonthPromotion: row.subMonthPromotion,
            subMonthAdjust: row.subMonthAdjust,
            subMonthNextPromotion: row.subMonthNextPromotion,
            subMonthNextPlan: row.subMonthNextPlan,
            resourceReserve: row.resourceReserve
          };
          let res = await this.$q.preSalePlan.prePlanPackUnSubEdit({data});
          if(res.success) {
            this.$message.success('修改成功')
          }else{
            this.$message.error(res.message)
          }
          this.$set(row, 'editable', false);
          this.init();
        }else{
            this.$message('请输入预估量')
        }
      })
    },
    // 历史销量
    historySale(row) {
      this.dialogType = 'history';
      this.rowData = row;
      this.dialogConfig = {
        title: '历史销量',
        showButton: false
      }
      this.historyVisible = true;
    },
    dialogConfirm() {

    },
    // 导入
    importFile() {
      this.openSubPage({
        path: '/dataImport/preSalePlanPackDataImport',
        // name: 'ImportExcel',
        query: {
          // fileType: Global.FILE_TYPE['预销计划包件信息'],
          fileName: '预销计划包件信息.xlsx',
          storeId: this.form.storeId,
          planTime: this.planTime,
          appCode: 'ec-pc-new'
        }
      })
    },
    //导出
 packExport() {
      let data = {
        ...this.formData,
        storeId: this.formData.storeId===null?this.form.storeId:this.formData.storeId,
        planTime: this.planTime,
        pageSize: 10000,
        pageNum: 1
      }
      let params = {
        appCode: "ec-pc-new",
        paramMap: data,
        reportName: "packSubmissionExport"
      };
      this.$q.orderDate.importExcel({ data: params }).then(res => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      });


    },
    async planSubmit() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: '数据正在导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      let data = {
        storeId: this.form.storeId,
        subTime: this.planTime
      };
      this.$q.preSalePlan.planSubmit({data:data})
      .then(res=>{
        if(res.success) {
          var timer = setInterval(function() {
              _this.$q.preSalePlan
                .getShopIsSubmit({params: {storeId:data.storeId,planTime:data.subTime}})
                .then(res => {
                  if (res.data == true) {
                    _this.$message.success('提报成功');
                    _this.init();
                    _this.$bus.$emit('monthRefresh', '');
                    _this.$emit('update:cachedComponents', []);
                    loading.close();
                    clearInterval(timer);
                  }
                })
                .catch(err => {
                  //this.$message(err.message)
                });
            }, 5000);
        }else{
          this.$message.fail(res.message);
        }
      }).catch(err => {
        loading.close();
      })
    },
    // 预估调整 input change
    handleNextMonthAdjustChange(row) {
      let subMonthDiffAmount = row.subMonthAdjust && row.subMonthAdjust - row.nextTwoPlan || '';
      row.subMonthDiffAmount = subMonthDiffAmount;
    },
    handleSortChange({column, prop, order}) {
      this.paginationOpt.pageNum = 1
      console.log({column, prop, order});
      if(order === null) {
        this.descOrAsc = '';
        this.fieldName = '';
      }
      if(order === 'ascending') {
        this.descOrAsc = '';
        this.fieldName = prop;
      }
      if(order === 'descending'){
        this.descOrAsc = 'desc';
        this.fieldName = prop;
      }
      this.init();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .ruleForm
    >>> .el-input--mini .el-input__inner
      width 90px

  >>> .el-form-item
    margin-bottom 0

   >>> tr td.tooltip .cell
    padding-right 28px


 >>> .el-table .is-scrolling-left+.el-table__fixed {
    display: none;
}
</style>
